module.exports = __webpack_public_path__ + "assets/063d2708584da7e70e4ff6ad830f8a96.mp3";


/*****************
 ** WEBPACK FOOTER
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/sounds/buttons/autos/auto_250.mp3
 ** module id = 32
 ** module chunks = 0
 **/